import { Component, Input } from '@angular/core';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';

@Component({
  selector: 'app-credit-card-conversion-banner',
  templateUrl: './credit-card-conversion-banner.component.html',
  styleUrls: ['./credit-card-conversion-banner.component.scss'],
  standalone: false,
})
export class CreditCardConversionBannerComponent {
  @Input() contentBanner : any;
  public imagePrefix: string;
  constructor(private mktEnvironmentService: MktEnvironmentService) { 
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }
}